<template>
  <v-col :style="forPartyEdit ? 'padding: 0px;' : ''">
    <v-form
      ref="form"
      @submit.prevent="submitForm"
    >
      <div :class="forPartyEdit? 'px-2' : 'pa-2'">
        <v-row align="start">
          <v-menu
            ref="menu"
            v-model="menuOpen"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template #activator="{ on }">
              <v-text-field
                ref="dateField"
                v-model="dateFormatted"
                :filled="!outlined"
                :outlined="outlined"
                autocomplete="off"
                :disabled="uncertainDate || inactive || disabled"
                :hint="hintText"
                :label="labelText"
                :placeholder="placeholderText"
                :style="forPartyEdit ? 'width:80%' : ''"
                persistent-hint
                :rules="rules.date"
                v-on="on"
                @change="parseManuallyEnteredDate"
                @focus="focusOpen"
                @keydown.tab="onTabOut"
              />
            </template>
            <v-date-picker
              v-model="dateInput"
              :max="maxDate"
              @input="menuOpen = false"
            />
          </v-menu>
          <v-checkbox
            ref="checkboxField"
            v-model="boxChecked"
            class="ml-2 shrink"
            hide-details
            :rules="rules.uncertain"
            :disabled="inactive || disabled"
          />
        </v-row>
      </div>
    </v-form>
  </v-col>
</template>

<script>
import { calculatedAge, dateISOFormat } from '@/utilities'
import dateFieldsMixin from '@/mixins/dateFields.js'

export default {
  name: 'BirthDateField',
  mixins: [dateFieldsMixin],

  props: {
    date: {
      type: String,
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    forPartyEdit: {
      type: Boolean,
      default: false,
    },

    inactive: {
      type: Boolean,
      default: false,
    },

    outlined: {
      type: Boolean,
      default: false,
    },

    required: {
      type: Boolean,
      default: false,
    },

    uncertain: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      dateFormatted: '',
      dateValidFromInput: true,
      maxDate: dateISOFormat(),
      menuOpen: false,
      rules: {
        date: [],
        uncertain: [],
      },
    }
  },

  computed: {
    age () {
      return calculatedAge(this.date)
    },

    boxChecked: {
      get () {
        return this.uncertain === true
      },

      set (newValue) {
        this.$emit('update-box', newValue)
      },
    },

    dateInput: {
      get () {
        return this.date
      },

      set (newDate) {
        this.dateFormatted = this.formatDate(newDate)
        if (newDate !== this.date) this.$emit('update-date', newDate)
      },
    },

    hintText () {
      return 'Check box if an ' + (this.date ? 'estimated' : 'uncertain') + ' date.'
    },

    labelText () {
      return this.dateValidFromInput
        ? 'Date of Birth' + (this.required ? ' *' : '') + (this.age ? ' (' + (this.boxChecked ? '~ ' : '') + this.age + ')' : '')
        : 'Date of Birth (invalid)'
    },

    placeholderText () {
      return this.uncertainDate ? 'Unknown' : 'MM/DD/YYYY'
    },
  },

  created () {
    this.dateFormatted = this.formatDate(this.dateInput)
    this.addComboValidation()
  },

  methods: {
    onTabOut () {
      this.menuOpen = false
      this.$emit('tab-out')
    },

    submitForm () {
      this.$emit('submit')
    },
  },
}
</script>
